v-container
  v-row
    v-col(cols="12")
      v-form(ref="formRef" v-model="valid" @submit.prevent="onSubmit")
        v-card
          v-card-text
            //- Title
            v-row
              v-col(cols="12")
                h2.text-h4.mb-4(v-html="$t('title')")

            //- Introduction
            v-row
              v-col(cols="12")
                p.text-body-1.mb-3(v-html="$t('intro.text')")
                ul.mb-4
                  li(v-for="(item, i) in $tm('intro.items')" :key="i" v-html="item")

            v-divider.my-4

            //- About Blepharoplasty
            v-row
              v-col(cols="12")
                p.text-body-1.mb-3(v-html="$t('about.text1')")
                p.text-body-1.mb-3(v-html="$t('about.text2')")
                ul.mb-4
                  li(v-for="(item, i) in $tm('about.items')" :key="i" v-html="item")

            v-divider.my-4

            //- Anesthesia and Benefits
            v-row
              v-col(cols="12")
                p.text-body-1.mb-3(v-html="$t('anesthesia.text1')")
                p.text-body-1.mb-3(v-html="$t('anesthesia.text2')")
                ul.mb-4
                  li(v-for="(item, i) in $tm('anesthesia.items')" :key="i" v-html="item")

            v-divider.my-4

            //- Alternatives
            v-row
              v-col(cols="12")
                p.text-body-1.mb-3(v-html="$t('alternatives.text')")
                ul.mb-4
                  li(v-for="(item, i) in $tm('alternatives.items')" :key="i" v-html="item")

            v-divider.my-4

            //- Risks
            v-row
              v-col(cols="12")
                p.text-body-1.mb-3(v-html="$t('risks.text')")
                ul.mb-4
                  li(v-for="(item, i) in $tm('risks.items')" :key="i" v-html="item")

            v-divider.my-4

            //- Consent
            v-row
              v-col(cols="12")
                p.text-body-1.mb-3(v-html="$t('consent.text')")
                ul.mb-4
                  li(v-for="(item, i) in $tm('consent.items')" :key="i" v-html="item")

            v-divider.my-6

            //- Surgery Selection
            v-row
              v-col(cols="12")
                p.text-body-1.mb-3.font-weight-bold(v-html="$t('surgery.text')")
            v-row
              v-col(cols="12" md="6")
                v-select(
                  v-model="form.upperLidSide"
                  :label="$t('surgery.upperLid')"
                  :items="form._attributes.upperLidSide.options.parse.args"
                  :rules="[form.validCheck('upperLidSide')]"
                )
              v-col(cols="12" md="6")
                v-select(
                  v-model="form.lowerLidSide"
                  :label="$t('surgery.lowerLid')"
                  :items="form._attributes.lowerLidSide.options.parse.args"
                  :rules="[form.validCheck('lowerLidSide')]"
                )

            v-divider.my-6

            //- Signature Section
            v-row
              v-col(cols="12")
                NameDateSignature(
                  v-model:name="form.name"
                  v-model:date="form.date"
                  v-model:signature="form.signature"
                  :name_rules="[form.validCheck('name')]"
                  :date_rules="[form.validCheck('date')]"
                  :signature_rules="[form.validCheck('signature')]"
                )

          v-card-actions.d-flex.justify-end
            if error
              .error.text-red-lighten-1 {{ error }}
            v-btn(color="primary" type="submit" :loading="loading") {{ $t('common.submit') }}

